import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './lib/auth';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { EventStreamProvider } from './lib/EventStreamContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Toaster } from './components/feedback/Toast';
import { InsightPopoverProvider } from './components/ui/InsightPopoverContext';
import { TourProvider } from './contexts/TourContext';
import { GuideModeProvider } from './components/onboarding/GuideModeContext';
import { AppRoutes } from './routes/AppRoutes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <PermissionsProvider>
              <SubscriptionProvider>
                <EventStreamProvider>
                  <InsightPopoverProvider>
                    <TourProvider>
                      <GuideModeProvider>
                        <AppRoutes />
                        <Toaster />
                      </GuideModeProvider>
                    </TourProvider>
                  </InsightPopoverProvider>
                </EventStreamProvider>
              </SubscriptionProvider>
            </PermissionsProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
